export enum EnumCapPeriod {
  Monthly = 1,
  OneTime = 2,
  Daily = 999, // UI purpose only. Exists only in posting sponsorship flow, NOT in campaign create flow
}
